import BaseCWTrainer from './BaseCWTrainer';
import { TOP_500_WORDS, DISPLAY_MODES } from './constants';
import { CwTrainer } from './cwTrainer';

export default class FullSequentialTopWordsCWTrainer extends BaseCWTrainer {


    // eslint-disable-next-line no-useless-constructor
    constructor(wpm, farnsworthWpm, useLetters, useNumbers, useSymbols, totalCharRepeats, displayMode, onDisplay) {
        super(wpm, wpm, useLetters, useNumbers, useSymbols, totalCharRepeats, displayMode, onDisplay);
        this.wordSentCounter = 0;
        this.numberOfWhiteSpaces = farnsworthWpm;
        this.whiteSpacesLength = 0;
        this.numberOfWordsRepetition = totalCharRepeats;
        this.wordLength = 0;
        this.chosenWord = '';
        this.chosenWordPart = '';
        this.arrayIndex = 0;
    }

    _getWhitespaces() {

        let ret = '';
        for(let i = 0; i < this.numberOfWhiteSpaces; i++) {
            ret += ' ';
        }
        this.whiteSpacesLength = ret.length;
        return ret;
    }

    _getTextToSend() {
        
        const min = 0;
        const max = TOP_500_WORDS.length -1;
        let text = '';

        if(this.wordSentCounter >= this.numberOfWordsRepetition){
            this.wordSentCounter = 0;

            if(this.arrayIndex < TOP_500_WORDS.length -1){
                this.arrayIndex++;
            }
            else {
                this.arrayIndex = 0;
            }
        }

        this.chosenWord = TOP_500_WORDS[this.arrayIndex];
        text = this.chosenWord + this._getWhitespaces();
        this.wordLength = this.chosenWord.length;

        if(this.numberOfWordsRepetition > 1) {
            for (let i = 1; i < this.numberOfWordsRepetition; i++) {
                text += this.chosenWord + this._getWhitespaces();
            }
        }

        this.textToSend = text;
        return text;
    }

    setDisplayMode(displayMode) {

        this.resetCwTrainerCallbacks();

        CwTrainer.getInstance().setBeforeCharCallback((character) => {

            if(this.chosenWordPart == '') {
                this.onDisplay('');
            }
        });

        CwTrainer.getInstance().setAfterCharCallback((character) => {

            this.chosenWordPart+= character;
            if (this.chosenWord === this.chosenWordPart.toLowerCase()) {
                this.onDisplay(this.chosenWord);
                this.chosenWordPart = '';
                this.wordSentCounter++;
            }
        });
    }

};